const $ = jQuery = require('jquery')

function close_accordion_section()
{
    $('.js-accordion .c-accordion_item_heading').removeClass('is-active');
    $('.js-accordion .c-accordion_item_content').slideUp(300).removeClass('is-open');
}

$('.c-accordion_item_heading').click(function(e)
{
    // Grab current anchor value
    var currentAttrValue = $(this).attr('href');

    if($(e.target).is('.is-active')) {
        close_accordion_section();
    }else {
        close_accordion_section();

        // Add active class to section title
        $(this).addClass('is-active');
        // Open up the hidden content panel
        $('.js-accordion ' + currentAttrValue).slideDown(300).addClass('is-open');
    }

    e.preventDefault();
});
